import { AISystemPromptManager } from '@/components/specifications/AISystemPromptManager';

export default function AdminAIPromptsPage() {
  return (
    <div className="container mx-auto max-w-5xl py-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">AI System Prompts</h1>
        <p className="text-muted-foreground mt-2">
          Configure and manage system prompts for the AI Specification Assistant
        </p>
      </div>
      <AISystemPromptManager />
    </div>
  );
}
